import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=62447697&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=62447697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62447697",
  null
  
)

export default component.exports